var _style, _path, _path2, _path3, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 120.002,
    height: 26.559,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style824"
  }, ".st0{fill:#34e0a1}")), /*#__PURE__*/React.createElement("g", {
    id: "g3207",
    transform: "scale(1.10662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3214"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9 12h3V9.5H9.3c-.1.8-.3 1.7-.3 2.5Zm5.9-4.6c-.6-1-1.2-1.7-1.9-1.9v2.9h2.4c-.2-.3-.3-.6-.5-1Zm-4.8 0c-.2.4-.3.7-.5 1.1H12V5.6c-.7.2-1.3.8-1.9 1.8zm0 10.2c.6 1 1.2 1.7 1.9 1.9v-2.9H9.6c.2.3.3.6.5 1zM9.2 7c.2-.4.4-.7.6-1-1.2.5-2.3 1.4-3 2.5h1.8Zm-.6 9.5H6.8c.8 1.1 1.8 2 3.1 2.5l-.6-.9c-.3-.6-.5-1.1-.7-1.6Zm-.3-7H6.2c-.4.8-.6 1.6-.7 2.5H8c0-.9.1-1.7.3-2.5ZM8 13H5.5c.1.9.3 1.7.7 2.5h2.1c-.2-.8-.3-1.7-.3-2.5Zm1.3 2.5H12V13H9c0 .8.2 1.7.3 2.5zM17 12h2.5c-.1-.9-.3-1.7-.7-2.5h-2.1c.2.8.3 1.6.3 2.5zm-1.8-6 .6.9c.2.5.5 1 .6 1.5h1.8c-.7-1-1.8-1.9-3-2.4Z",
    id: "path826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20 0H4C1.8 0 0 1.8 0 4v16c0 2.2 1.8 4 4 4h16c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4Zm-1.8 18.2c-1.5 1.5-3.5 2.3-5.7 2.3s-4.2-.8-5.7-2.3c-1.5-1.5-2.3-3.5-2.3-5.7s.8-4.2 2.3-5.7c1.5-1.5 3.5-2.3 5.7-2.3s4.2.8 5.7 2.3c1.5 1.5 2.3 3.5 2.3 5.7s-.8 4.2-2.3 5.7z",
    id: "path828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7 15.5h2.1c.4-.8.6-1.6.7-2.5H17c0 .8-.1 1.7-.3 2.5zM16 13h-3v2.5h2.7c.1-.8.3-1.6.3-2.5Zm-.2 5-.6.9c1.2-.5 2.3-1.4 3.1-2.5h-1.8c-.3.6-.5 1.1-.7 1.6Zm-.1-8.5H13V12h3c0-.8-.2-1.7-.3-2.5zm-2.7 7v2.9c.7-.2 1.3-.8 1.9-1.9.2-.3.3-.7.5-1.1H13Z",
    id: "path830"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "21.3333px",
      lineHeight: 1.25,
      fontFamily: "'Century Gothic'",
      InkscapeFontSpecification: "'Century Gothic, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 26.919,
    y: 19.628,
    id: "text1686"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1684",
    x: 26.919,
    y: 19.628
  }, "Website"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteLogo);
export default __webpack_public_path__ + "static/media/Website_Logo.ed0521a351ade4989147b093a5fc4fe1.svg";
export { ForwardRef as ReactComponent };